export const shortenPhrase = (title: string, limit: number): string => {
  return title.length > limit ? `...${title.substring(title.length - limit, title.length)}` : title;
};
